// extracted by mini-css-extract-plugin
export var alignCenter = "_7p-d";
export var bannerShown = "_7p-6";
export var buttonContent = "_7p-0";
export var cardList = "_7p-1";
export var centerContent = "_7p-2";
export var chevron = "_7p-3";
export var closePanelButton = "_7p-k";
export var conversationContextContainer = "_7p-l";
export var conversationDetailContainer = "_7p-4";
export var detailWrapper = "_7p-7";
export var dropdownButton = "_7p-e";
export var dropdownTitle = "_7p-9";
export var fullHeight = "_7p-5";
export var hidden = "_7p-a";
export var icon = "_7p-b";
export var mergeSuggestionWrapper = "_7p-m";
export var panel = "_7p-i";
export var portalButtonsWrapper = "_7p-c";
export var right = "_7p-j";
export var tableSummaryContainer = "_7p-8";
export var tableSummaryHeader = "_7p-g";
export var threeDotsButton = "_7p-f";
export var wide = "_7p-h";